export const SET_INCOME_STATEMENT_FILTER = "SET_INCOME_STATEMENT_FILTER"
export const GET_INCOME_STATEMENT_FILTER = "GET_INCOME_STATEMENT_FILTER"

export const GET_INCOME_STATEMENT = "GET_INCOME_STATEMENT"
export const GET_INCOME_STATEMENT_SUCCESS = "GET_INCOME_STATEMENT_SUCCESS"
export const GET_INCOME_STATEMENT_ERROR = "GET_INCOME_STATEMENT_ERROR"
